import { OidcResult } from '@cigna/shared/angular/auth/oidc-util';
import { createAction, props } from '@ngrx/store';
import { SigninWithCredentialsOptions } from '@okta/okta-auth-js';

import {
  FactorVerify,
  SignInFailReason,
  AuthTransaction,
  LogoutVariations,
} from './login.models';

export const signIn = createAction(
  '[Login] Start Sign-in',
  props<{ options: SigninWithCredentialsOptions }>(),
);

export const signInSuccess = createAction('[Login] Sign-in Success');

export const signInFailed = createAction(
  '[Login] Sign-in Failed',
  props<{ reason: SignInFailReason }>(),
);

export const updateTransaction = createAction(
  '[Login] Update Transaction',
  props<{ transaction: AuthTransaction }>(),
);

export const sendCodeToFactor = createAction(
  '[Login] Send Code to Factor',
  props<{ factor: FactorVerify; canGoBack: boolean }>(),
);

export const resendCodeToFactor = createAction('[Login] Resend Code to Factor');

export const verifyFactor = createAction(
  '[Login] Verify Factor',
  props<{ code: string; rememberDevice: boolean }>(),
);

export const exchangeToken = createAction(
  '[Login] Get Token',
  props<{ sessionToken: string }>(),
);

export const enrollEmailFactor = createAction('[Login] Enroll Email Factor');

export const enrollPhoneFactor = createAction(
  '[Login] Enroll Phone Factor',
  props<{ phoneNumber: string }>(),
);

export const onNewRegistration = createAction(
  '[Login] On New Registration',
  props<{ phoneNumber: string }>(),
);

export const activateFactor = createAction(
  '[Login] Activate Factor',
  props<{ code: string }>(),
);

export const skipEnrollFactor = createAction('[Login] Skip Enroll Factor');

export const goBack = createAction('[Login] Go Back');

export const cancelTransaction = createAction('[Login] Cancel Transaction');

export const prevTransaction = createAction('[Login] Previous Transaction');

export const impersonate = createAction('[Login] Impersonate');

export const federate = createAction('[Login] Federate');

export const impersonateSuccess = createAction(
  '[Login] Impersonate Success',
  props<{ payload: Partial<OidcResult> }>(),
);

export const logout = createAction(
  '[Login] Logout Triggered',
  props<{ variation: LogoutVariations; linkName: string }>(),
);
